export const TIMELINE_PERMISSION = "MILL.GetOperationsTimeline";
export const MAX_RANGE_DAYS = 31;
export const MINUTE = 60_000;
export const KEY_STANDS = [1, 9, 15, 17] as const;
export type TimelineView = "parallel" | "stands";
export type DetailLevel = "individual" | "summary";
export type EventKind = "billet" | "campaign" | "workOrder" | "stop" | "roll";
export type NavigatorKind = Exclude<EventKind, "billet"> | "cobble";
export interface Selection {
	kind: EventKind;
	id: number;
}
export interface TimeRange {
	start: number;
	end: number;
}
export interface Interval {
	Id: number;
	start: number;
	end: number | null;
}
export interface Passage {
	BilletId: number;
	StandId: number;
	start: number;
	end: number;
}
export interface Billet extends Interval {
	lastObservedEnd: number | null;
	TrackingId: number | null;
	IsGood: boolean | null;
	IsEstimated: boolean;
	CampaignId: number | null;
	WorkOrderId: number | null;
	WorkOrder: string | null;
	SectionCode: string | null;
	Product: string | null;
	Heat: string | null;
	Grade: string | null;
	BilletWeight: number | null;
	Length: number | null;
	ShiftId: string | null;
	CrewId: string | null;
	BilletHeight: number | null;
	BilletWidth: number | null;
	StartTemperatureAvg: number | null;
	EndTemperatureAvg: number | null;
	StartTemperatureMin: number | null;
	StartTemperatureMax: number | null;
	EndTemperatureMin: number | null;
	EndTemperatureMax: number | null;
	passages: Passage[];
}
export interface Campaign extends Interval {
	nextStart?: number | null;
	SectionCode: string | null;
	Product: string | null;
}
export interface WorkOrder extends Campaign {
	WorkOrderId: number | null;
	WorkOrder: string | null;
	FirstBilletId: number;
}
export interface Stop extends Interval {
	Cause: string | null;
	DelayCodePath: string | null;
	Category: string | null;
	Comments: string | null;
	CampaignId: number | null;
	IsMicroDelay: boolean;
	IsDelayManual: boolean;
}
export interface RollChange extends Interval {
	StandId: number;
	Stand: string;
	CampaignId: number | null;
	InstalledRollset: string | null;
	PreviousRollset: string | null;
}
export interface TimelineData {
	billets: Billet[];
	campaigns: Campaign[];
	workOrders: WorkOrder[];
	stops: Stop[];
	rolls: RollChange[];
}
export interface NavigationEvent extends Selection {
	time: number;
}
export const NAVIGATORS: {
	kind: NavigatorKind;
	label: string;
	color: string;
}[] = [
	{ kind: "campaign", label: "Campaign", color: "#7542aa" },
	{ kind: "workOrder", label: "WO change", color: "#2465b8" },
	{ kind: "cobble", label: "Cobble", color: "#b52f4e" },
	{ kind: "stop", label: "Stop", color: "#946300" },
	{ kind: "roll", label: "Roll change", color: "#8055ad" },
];
